<template>
  <div class="content h-100">
    <van-sticky>
      <div class="d-flex flex-row justify-content-center align-items-center search-box">
        <input placeholder="请输入关键字" v-model="mySearchValue" placeholder-class="placeholder"/>
        <van-icon name="close" class="icon-close" v-if="searchValue" @click="clearValue"/>
        <span @click="search">搜索</span>
      </div>
    </van-sticky>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'search',
  model: {
    prop: 'searchValue',
    event: 'changeSearchValue'
  },
  props: {
    searchValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mySearchValue: this.searchValue,
    };
  },
  methods: {
    search () {
      this.$emit('search', this.mySearchValue)
    },
    clearValue() {
      this.$emit('clear')
    }
  },
  watch: {
    searchValue (newVal) {
      this.mySearchValue = newVal
    },
    mySearchValue (newVal) {
      this.$emit('changeSearchValue', newVal)
    }
  },
}
</script>

<style lang="scss" scoped>
page,
.content {
  background: $page-color-base;
}

.search-box {
  height: 45px;
  z-index: 21;
  width: 100%;
  padding: 2px 15px;
  background-color: white;
  position: relative;

  input {
    height: 35px;

    flex: 1;
    border-radius: 17px;
    background-color: rgb(248, 248, 248);
    padding: 5px 15px;
    font-size: 14px;
  }

  span {
    font-size: 15px;
    color: grey;
    height: 30px;
    line-height: 30px;
    padding-left: 5px;
  }
  .icon-close {
    position: absolute;
    right: 63px;
    top: 14px;
    z-index: 999;
  }
}
</style>
